import { createFileRoute } from "@tanstack/react-router";
import { SigningScreen } from "./-components/signing-screen";

export const Route = createFileRoute("/sign/$token")({
  component: SignPage,
});

function SignPage() {
  return <SigningScreen token={Route.useParams().token} />;
}
